//Auto fill in contact form

const autoInput = document.querySelector(".auto-title");
const title = document.querySelector("h1");

if (autoInput && title && window.location.pathname.split("/").length > 3) {
  autoInput.value = title.innerText;
  autoInput.setAttribute("readonly", "readonly");
}
